module.exports = __webpack_public_path__ + "static/media/sat.8a4ec566.svg";